// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Deployments__MerchantsController from "./deployments/merchants_controller"
application.register("deployments--merchants", Deployments__MerchantsController)

import DeploymentsController from "./deployments_controller"
application.register("deployments", DeploymentsController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NestedFieldsController from "./nested_fields_controller"
application.register("nested-fields", NestedFieldsController)

import PurchaseOrderItemsController from "./purchase_order_items_controller"
application.register("purchase-order-items", PurchaseOrderItemsController)

import ScanController from "./scan_controller"
application.register("scan", ScanController)

import Search__ConditionController from "./search/condition_controller"
application.register("search--condition", Search__ConditionController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import TvMerchantsCycleController from "./tv_merchants_cycle_controller"
application.register("tv-merchants-cycle", TvMerchantsCycleController)

import TvRefreshController from "./tv_refresh_controller"
application.register("tv-refresh", TvRefreshController)
